import * as actionTypes from './action-types'
import * as mutationTypes from './mutation-types'
import network from '@/utils/network'
import { REFRESH_DATA } from '@/store/action-types'
import { SERVICE_SET_ACTIVE } from '@/store/modules/service/mutation-types'
import { USER_AGENCY_FETCH_INFOS, USER_AGENCY_GET_PRICING } from '@/store/modules/user/agency/action-types'
import { SERVICE_ROUND_SET_ACTIVE } from '@/store/modules/service/rounds/mutation-types'
import {
  USER_AGENCY_SET_AGENCY,
  USER_AGENCY_SET_AGENTS,
  USER_AGENCY_SET_CLIENTS,
  USER_AGENCY_SET_SITES
} from '@/store/modules/user/agency/mutation-types'
import { patchAgencyPlan, postAgency, putAgency } from '@/utils/api/agency'
import { putUser } from '@/utils/api/user'

let refreshRequest = null
export default {
  [actionTypes.USER_LOGIN]: async ({ commit, dispatch }, payload) => {
    const r = await network.post('oauth/v2/token', {
      grant_type: 'password',
      client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
      client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k',
      ...payload
    })
    commit(mutationTypes.USER_SET_TOKEN, r.data)
    commit(mutationTypes.USER_ADD_PREV_LOGIN, payload)
    await dispatch(REFRESH_DATA, null, { root: true })
  },
  [actionTypes.USER_PUT_USER]: async ({ state: { utilisateur: { id } }, commit, dispatch }, _user) => {
    const { user } = await putUser({
      id,
      ..._user
    })
    commit(mutationTypes.USER_SET_USER, user)
  },
  [actionTypes.USER_TOKEN_REFRESH]: async ({ commit, getters: { authToken } }) => {
    if (!authToken) {
      throw new Error('Vous devez vous reconnecter')
    }
    if (refreshRequest) {
      await refreshRequest
    } else {
      refreshRequest = network.post('oauth/v2/token', {
        grant_type: 'refresh_token',
        client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
        client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k',
        refresh_token: authToken.refresh_token
      })
      try {
        const r = await refreshRequest
        commit(mutationTypes.USER_SET_TOKEN, r.data)
        refreshRequest = null
      } catch (e) {
        refreshRequest = null
        throw new Error(`Échec du rafraîchissement du token...`)
      }
    }
  },
  [actionTypes.USER_LOGOUT]: ({ commit }) => {
    // TODO Info au serveur ?
    commit(mutationTypes.USER_SET_TOKEN, null)
    commit(mutationTypes.USER_SET_USER, {})
    commit(mutationTypes.USER_SET_ALTERATE_PROFILE, null)
    commit(mutationTypes.USER_SET_ALTERATED_AGENCY, null)
    // Nettoyage agence
    commit('user/agency/' + USER_AGENCY_SET_SITES, [], { root: true })
    commit('user/agency/' + USER_AGENCY_SET_AGENTS, [], { root: true })
    commit('user/agency/' + USER_AGENCY_SET_CLIENTS, [], { root: true })
    // Nettoyage service
    commit('service/' + SERVICE_ROUND_SET_ACTIVE, null, { root: true })
    commit('service/' + SERVICE_SET_ACTIVE, null, { root: true })
  },
  [actionTypes.USER_FETCH_USER]: async ({ commit }) => {
    const r = await network.get('user')
    commit(mutationTypes.USER_SET_USER, r.data.user)
  },
  [actionTypes.USER_ALTERATE_PROFILE]: async ({ commit }, profile) => {
    // TODO Info au serveur ?
    commit(mutationTypes.USER_SET_ALTERATE_PROFILE, profile)
  },
  [actionTypes.USER_ALTERATE_AGENCY]: async ({ commit, dispatch }, agency) => {
    // TODO Info au serveur ?
    commit(mutationTypes.USER_SET_ALTERATED_AGENCY, agency)
    await dispatch('user/agency/' + USER_AGENCY_FETCH_INFOS, null, { root: true })
  },
  [actionTypes.USER_PUT_AGENCY]: async ({ state, commit, getters, dispatch, rootGetters }, _agency) => {
    const { agency } = await (
      _agency.id
        ? putAgency(_agency)
        : postAgency(_agency))
    if (getters.isAdmin) {
      commit(`user/agency/${USER_AGENCY_SET_AGENCY}`, agency, { root: true })
    } else {
      commit(mutationTypes.USER_SET_USER_AGENCY, agency)
    }
    if (!_agency.id) {
      await dispatch(mutationTypes.USER_SET_ALTERATED_AGENCY, agency.slug)
    }
  },
  [actionTypes.USER_PATCH_AGENCY_PLAN]: async ({ state, commit, dispatch }, options) => {
    const { agency } = await patchAgencyPlan(options)
    commit(mutationTypes.USER_SET_USER_AGENCY, agency)
    await dispatch(`user/agency/${USER_AGENCY_GET_PRICING}`, null, { root: true })
  }
}
